var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"top-row"},[_c('h4',[_vm._v("Senaste statistiken")])]),_c('div',{staticClass:"pa-3"},[_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" Kommande funktion ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }